import { supabase } from '@/core/database/supabase';
import { permissionEngine, type PermissionContext } from '@/core/permissions';

export async function getCurrentUserId() {
  const { data, error } = await supabase.auth.getUser();
  if (error || !data.user?.id) {
    throw new Error('Không thể xác định người dùng hiện tại');
  }
  return data.user.id;
}

export async function enforceSettingsPermission(permissionKey: string, context: PermissionContext = {}) {
  const userId = await getCurrentUserId();
  await permissionEngine.assert(userId, permissionKey, context);
  return userId;
}
